<template>
  <!-- 总 -->
  <div>
    <!-- 销售团队 -->
    <div
      style="
        height: 145px;
        background: #0067b3;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 35px;
      "
    >
      {{ $t("联系我们.销售团队") }}
    </div>
    <!-- 销售团队 -->
    <!-- 销售团队明细 -->
    <div
      style="
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 40px 10% 0px 10%;
        background-color: #f2f3f3;
      "
    >
      <div v-for="(item, index) in team1" :key="index" class="right">
        <img
          :src="
            item.photo1 ||
            'https://img0.baidu.com/it/u=560023973,3091302950&amp;fm=253&amp;fmt=auto&amp;app=138&amp;f=JPEG?w=489&amp;h=619'
          "
          alt="图片加载失败"
          class="team-photo"
        />
        <div class="team-background">
          <div class="team-name">{{ item.name1 }}</div>
          <div class="team-tel">{{ item.tel1 }}</div>
          <div class="team-email">{{ item.email1 }}</div>
        </div>
      </div>
    </div>
    <!-- 销售团队明细 -->
    <!-- 采购团队 -->
    <div
      style="
        height: 145px;
        background: #0067b3;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 35px;
      "
    >
      {{ $t("联系我们.采购团队") }}
    </div>
    <!-- 采购团队 -->
    <!-- 采购团队明细 -->
    <div
      style="
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 40px 10% 30px 10%;
        background-color: #f2f3f3;
      "
    >
      <div v-for="(item, index) in team2" :key="index" class="right">
        <img
          :src="
            item.photo2 ||
            'https://img0.baidu.com/it/u=560023973,3091302950&amp;fm=253&amp;fmt=auto&amp;app=138&amp;f=JPEG?w=489&amp;h=619'
          "
          alt="图片加载失败"
          class="team-photo"
        />
        <div class="team-background">
          <div class="team-name">{{ item.name2 }}</div>
          <div class="team-tel">{{ item.tel2 }}</div>
          <div class="team-email">{{ item.email2 }}</div>
        </div>
      </div>
    </div>
    <!-- 采购团队明细 -->
    <!-- 主要销售地点 -->
    <div
      style="
        height: 145px;
        background: #0067b3;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 35px;
      "
    >
      {{ $t("联系我们.主要销售地点") }}
    </div>
    <!-- 主要销售地点左文右图 -->
    <div style="padding: 0px 10% 30px 10%">
      <!-- 左右两部分 -->
      <div
        style="display: flex; justify-content: space-between; flex-wrap: wrap"
      >
        <!-- 左侧文本 -->
        <div style="padding: 0px 30px 30px 0">
          <img
            src="@/assets/changtiaologo.png"
            alt="图片加载失败"
            style="
              height: 60px;
              width: auto;
              margin-top: 100px;
              margin-bottom: 20px;
            "
          />
          <div style="font-size: 18px; font-weight: bold; margin-bottom: 20px">
            {{ $t("联系我们.捷丰销售地点地址") }}
          </div>
          <!-- 左侧文本 -->
          <!-- <div
            style="
              display: flex;
              justify-content: flex-start;
              flex-wrap: wrap;
              cursor: pointer;
            "
            @click="showModal2"
          > -->
          <div
            style="
              display: flex;
              justify-content: flex-start;
              flex-wrap: wrap;
              cursor: pointer;
            "
            @click="openMap1"
          >
            <a-modal
              cancel-text="取消"
              ok-text="确定"
              v-model="visible2"
              @ok="handleOk2"
              :width="800"
            >
              <div id="amap2" style="height: 400px"></div>
            </a-modal>
            <a-icon
              type="environment"
              style="font-size: 25px; margin-right: 5px; margin-top: 6px"
            />
            <div style="font-size: 25px">{{ $t("联系我们.在地图中显示") }}</div>
          </div>
          <!-- 左侧文本 -->
          <div style="font-size: 18px; font-weight: bold; margin-top: 20px">
            {{ $t("联系我们.仓库面积达40000平方米") }}
          </div>
        </div>
        <!-- 左侧文本 -->
        <!-- 右侧图片 -->
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 40px;
          "
        >
          <div>
            <img
              src="@/assets/company.png"
              style="width: 800px; height: auto"
            />
          </div>
        </div>
        <!-- 右侧图片 -->
      </div>
      <!-- 左右两部分 -->
    </div>
    <!-- 主要销售地点左文右图 -->
    <!-- 主要销售地点 -->
    <!-- 核心仓库 -->
    <div
      style="
        height: 145px;
        background: #0067b3;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 35px;
      "
    >
      {{ $t("联系我们.核心仓库") }}
    </div>
    <!-- 核心仓库左图右文 -->
    <div style="padding: 0px 10% 30px 10%">
      <!-- 左右两部分 -->
      <div
        style="display: flex; justify-content: space-between; flex-wrap: wrap"
      >
        <!-- 左侧图片 -->
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 40px;
          "
        >
          <div>
            <img
              src="@/assets/company.png"
              style="width: 800px; height: auto"
            />
          </div>
        </div>
        <!-- 左侧图片 -->
        <!-- 右侧文本 -->
        <div style="padding: 0px 30px 30px 0">
          <img
            src="@/assets/changtiaologo.png"
            alt="图片加载失败"
            style="
              height: 60px;
              width: auto;
              margin-top: 100px;
              margin-bottom: 20px;
            "
          />
          <div style="font-size: 18px; font-weight: bold; margin-bottom: 20px">
            {{ $t("联系我们.捷丰核心仓库地址") }}
          </div>
          <!-- 左侧文本 -->
          <!-- <div
            style="
              display: flex;
              justify-content: flex-start;
              flex-wrap: wrap;
              cursor: pointer;
            "
            @click="showModal"
          > -->
          <div
            style="
              display: flex;
              justify-content: flex-start;
              flex-wrap: wrap;
              cursor: pointer;
            "
            @click="openMap2"
          >
            <a-modal
              cancel-text="取消"
              ok-text="确定"
              v-model="visible"
              @ok="handleOk"
              :width="800"
            >
              <div id="amap" style="height: 400px"></div>
            </a-modal>
            <a-icon
              type="environment"
              style="font-size: 25px; margin-right: 5px; margin-top: 6px"
            />
            <div style="font-size: 25px">{{ $t("联系我们.在地图中显示") }}</div>
          </div>
          <!-- 左侧文本 -->
          <div style="font-size: 18px; font-weight: bold; margin-top: 20px">
            {{ $t("联系我们.仓库距离货运公路2,000米") }}
          </div>
        </div>
        <!-- 右侧文本 -->
      </div>
      <!-- 左右两部分 -->
    </div>
    <!-- 核心仓库左图右文 -->
    <!-- 核心仓库 -->
    <!-- 其他 -->
    <div
      style="
        height: 145px;
        background: #0067b3;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 35px;
      "
    >
      {{ $t("联系我们.其他") }}
    </div>
    <!-- 其他两边文字 -->
    <div style="padding: 30px 20% 30px 10%">
      <!-- 左右两部分 -->
      <div
        style="display: flex; justify-content: space-between; flex-wrap: nowrap"
      >
        <!-- 左侧文本 -->
        <div>
          <div style="margin-bottom: 20px">
            <div style="font-size: 18px; font-weight: bold">
              {{ $t("联系我们.捷丰林合工业设备(上海)有限公司") }}
            </div>
            <div style="font-size: 18px">
              {{ $t("联系我们.江苏省太仓市陆渡镇江南路81号丰田叉车") }}
            </div>
          </div>
          <div
            style="display: flex; justify-content: flex-start; flex-wrap: wrap"
          >
            <div style="font-size: 18px; font-weight: bold">
              {{ $t("联系我们.统一社会信用代码：") }}
            </div>
            <div style="font-size: 18px">91310120324706632P</div>
          </div>
          <div style="margin-top: 20px">
            <div
              style="
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;
              "
            >
              <div style="font-size: 18px; font-weight: bold">
                {{ $t("联系我们.销售服务热线:") }}
              </div>
              <div style="font-size: 18px">186-1607-8111 177-9864-4835</div>
            </div>
          </div>
        </div>
        <!-- 左侧文本 -->
        <!-- 右侧文本 -->
        <div>
          <div
            style="
              margin-bottom: 20px;
              display: flex;
              justify-content: flex-start;
              flex-wrap: wrap;
            "
          >
            <div style="font-size: 18px; font-weight: bold">
              {{ $t("联系我们.开户行：") }}
            </div>
            <div style="font-size: 18px">
              {{ $t("联系我们.中国银行上海市宁虹路支行") }}
            </div>
          </div>
          <div
            style="
              margin-bottom: 10px;
              display: flex;
              justify-content: flex-start;
              flex-wrap: wrap;
            "
          >
            <div style="font-size: 18px; font-weight: bold">
              {{ $t("联系我们.银行账号：") }}
            </div>
            <div style="font-size: 18px">442968492120</div>
          </div>
        </div>
        <!-- 右侧文本 -->
      </div>
      <!-- 左右两部分 -->
    </div>
    <!-- 其他两边文字 -->
    <!-- 其他 -->
  </div>
  <!-- 总 -->
</template>

<script>
import axios from "axios";
import AMapLoader from "@amap/amap-jsapi-loader";
export default {
  components: {},
  data() {
    return {
      team1: [],
      team2: [],
      visible: false,
      visible2: false,
    };
  },
  mounted() {
    this.xiaoshou();
    this.caigou();
  },
  methods: {
    openMap1() {
      const imageUrl =
        // "https://map.baidu.com/poi/捷丰林合工业设备有限公司/@13491455.124999998,3674498.0000000005,19z?uid=7fe30561dfc2155ddeee8bc1&info_merge=1&isBizPoi=false&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&pcevaname=pc4.1&querytype=detailConInfo&da_src=shareurl";
        "https://map.qq.com/?addr=%E6%B1%9F%E8%8B%8F%E7%9C%81%E8%8B%8F%E5%B7%9E%E5%B8%82%E5%A4%AA%E4%BB%93%E5%B8%82%E5%8F%8C%E5%87%A4%E9%95%87%E5%AF%8C%E8%B1%AA%E7%BB%8F%E6%B5%8E%E5%BC%80%E5%8F%91%E5%8C%BA%E5%B9%BF%E5%B7%9E%E8%A5%BF%E8%B7%AF%E4%B8%8E204%E5%9B%BD%E9%81%93%E4%BA%A4%E6%B1%87%E5%A4%84%28%E5%A4%A7%E9%97%A8%E8%BF%9B%E5%8E%BB%E7%9B%B4%E8%B5%B0%E5%B7%A6%E6%89%8B%E8%BE%B9%E7%AC%AC%E4%B8%80%E5%B9%A2%E6%8D%B7%E4%B8%B0%29&isopeninfowin=1&markertype=1&name=%E6%8D%B7%E4%B8%B0%E4%BA%8C%E6%89%8B%E5%8F%89%E8%BD%A6%E4%B8%AD%E5%BF%83&pointx=121.073&pointy=31.4761&ref=WeChat&type=marker";
      window.open(imageUrl, "_blank");
    },
    openMap2() {
      const imageUrl =
        // "https://map.baidu.com/poi/捷丰林合工业设备有限公司/@13491455.124999998,3674498.0000000005,19z?uid=7fe30561dfc2155ddeee8bc1&info_merge=1&isBizPoi=false&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&pcevaname=pc4.1&querytype=detailConInfo&da_src=shareurl";
        "https://map.qq.com/?addr=%E6%B1%9F%E8%8B%8F%E7%9C%81%E8%8B%8F%E5%B7%9E%E5%B8%82%E5%A4%AA%E4%BB%93%E5%B8%82%E5%8F%8C%E5%87%A4%E9%95%87%E5%AF%8C%E8%B1%AA%E7%BB%8F%E6%B5%8E%E5%BC%80%E5%8F%91%E5%8C%BA%E5%B9%BF%E5%B7%9E%E8%A5%BF%E8%B7%AF%E4%B8%8E204%E5%9B%BD%E9%81%93%E4%BA%A4%E6%B1%87%E5%A4%84%28%E5%A4%A7%E9%97%A8%E8%BF%9B%E5%8E%BB%E7%9B%B4%E8%B5%B0%E5%B7%A6%E6%89%8B%E8%BE%B9%E7%AC%AC%E4%B8%80%E5%B9%A2%E6%8D%B7%E4%B8%B0%29&isopeninfowin=1&markertype=1&name=%E6%8D%B7%E4%B8%B0%E4%BA%8C%E6%89%8B%E5%8F%89%E8%BD%A6%E4%B8%AD%E5%BF%83&pointx=121.073&pointy=31.4761&ref=WeChat&type=marker";
      window.open(imageUrl, "_blank");
    },
    showModal2() {
      this.visible2 = true;
      this.initMap2(); // 调用初始化地图的方法
    },
    initMap2() {
      AMapLoader.load({
        key: "93a2bc421fe24dc7e31c71276380b0b3", // 请确保这是您有效的高德地图API密钥
        version: "2.0",
        plugins: ["AMap.InfoWindow"], // 确保您已经加载了InfoWindow插件
      })
        .then((AMap) => {
          const map2 = new AMap.Map("amap2", {
            resizeEnable: true, // 是否监控地图容器尺寸变化
            zoom: 10, // 初始化地图级别
            center: [121.19, 31.49], // 初始化地图中心点，这里以北京天安门为例
          });

          // 添加初始地点标记
          const marker = new AMap.Marker({
            position: new AMap.LngLat(121.19, 31.49), // 设置标记的经纬度
            map: map2, // 在哪个地图上显示标记
          });

          // 创建信息窗口内容
          const content = "<div>捷丰林合工业设备（上海）有限公司</div>";

          // 创建信息窗口实例
          const infoWindow = new AMap.InfoWindow({
            content: content,
            offset: new AMap.Pixel(0, -20), // 信息窗口距离标记的偏移量
          });

          // 直接打开信息窗口，不需要点击事件
          infoWindow.open(map2, marker.getPosition()); // 使用map2变量而不是map

          // ... 你可以在这里添加更多关于标记的配置，比如其他事件等
        })
        .catch((e) => {
          console.error(e);
          // 错误处理
        });
    },
    handleOk2(e) {
      console.log(e);
      this.visible2 = false;
    },
    showModal() {
      this.visible = true;
      this.initMap(); // 调用初始化地图的方法
    },
    initMap() {
      AMapLoader.load({
        key: "93a2bc421fe24dc7e31c71276380b0b3",
        version: "2.0",
      })
        .then((AMap) => {
          const map = new AMap.Map("amap", {
            resizeEnable: true, // 是否监控地图容器尺寸变化
            zoom: 10, // 初始化地图级别
            center: [121.19, 31.49], // 初始化地图中心点，这里以北京天安门为例
          });

          // 添加初始地点标记
          const marker = new AMap.Marker({
            position: new AMap.LngLat(121.19, 31.49), // 设置标记的经纬度
            map: map, // 在哪个地图上显示标记
          });

          // 创建信息窗口内容
          const content = "<div>捷丰林合工业设备（上海）有限公司</div>";

          // 创建信息窗口实例
          const infoWindow = new AMap.InfoWindow({
            content: content,
            offset: new AMap.Pixel(0, -20), // 信息窗口距离标记的偏移量
          });

          // 直接打开信息窗口，不需要点击事件
          infoWindow.open(map, marker.getPosition());

          // ... 你可以在这里添加更多关于标记的配置，比如其他事件等
        })
        .catch((e) => {
          console.error(e);
          // 错误处理
        });
    },
    handleOk(e) {
      console.log(e);
      this.visible = false;
    },
    xiaoshou() {
      axios
        .post(this.$apiUrl + "/api/general/queryMulti", {
          tableName: "jf_web_sales_buyer",
          filters: {
            xiaoshoucaigou: [
              {
                dataIndex: "position",
                operator: "eq", // eq 等于 neq 不等于
                value: "销售",
              },
            ],
          },
          offset: 0,
          limit: 10,
        })
        .then((res) => {
          console.log(res);
          this.team1 = res.data.data.map((item) => {
            return {
              photo1: item.avatar,
              name1: item.name,
              tel1: item.cellphone,
              email1: item.email,
            };
          });
        });
    },
    caigou() {
      axios
        .post(this.$apiUrl + "/api/general/queryMulti", {
          tableName: "jf_web_sales_buyer",
          filters: {
            xiaoshoucaigou: [
              {
                dataIndex: "position",
                operator: "eq", // eq 等于 neq 不等于
                value: "采购",
              },
            ],
          },
          offset: 0,
          limit: 10,
        })
        .then((res) => {
          console.log(res);
          this.team2 = res.data.data.map((item) => {
            return {
              photo2: item.avatar,
              name2: item.name,
              tel2: item.cellphone,
              email2: item.email,
            };
          });
        });
    },
  },
};
</script>

<style scoped>
/* 悬停放大 */
.right {
  /* 添加过渡效果，这样阴影和放大都能有动画 */
  transition: transform 0.1s ease, box-shadow 0.1s ease;
}

.right:hover {
  /* 悬停时放大 */
  transform: scale(1.05);
  /* 悬停时改变阴影效果，使其更明显 */
  /* box-shadow: 8px 8px 8px rgba(0, 0, 0, 0.3); */
}
/* 悬停放大 */
.team-background {
  position: relative;
  width: 350px;
  background-color: white;
  margin-bottom: 30px;
  padding-bottom: 20px;
}
.team-background::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1; /* 将伪元素置于内容下方 */
  margin: -1px; /* 减去边框宽度，如果边框为0则不需要这个 */
  padding: 50px; /* 与内边距相同，确保阴影从内容区域开始 */
  background-color: #fff; /* 与背景色相同，确保不看到额外的背景 */
  box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.19); /* 添加阴影 */
}
.team-photo {
  width: 350px;
  height: 300px;
}
.team-name {
  width: 350px;
  height: 50px;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  color: white;
  background-color: #0067b3;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.team-tel {
  width: 350px;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
}
.team-email {
  width: 350px;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  color: #0067b3;
}
</style>
